import React from 'react';
import Type from 'prop-types';
import { ListItem, ListItemText, ListItemSecondaryAction } from "@mui/material";
import { FormattedNumber } from 'components';
import { useTranslation } from 'hooks';
import styles from './PaymentItem.module.css';

const PaymentItem = (props) => {
  const {
    operation: { contractNumber, comment, amount },
  } = props;
  const { t } = useTranslation();

  return (
    <ListItem button>
      <ListItemText
        primary={`${t('contract')}: ${contractNumber}`}
        secondary={comment.length > 0 ? comment : null}
        secondaryTypographyProps={{
          classes: {
            root: styles.comment,
          },
        }}
      />

      <ListItemSecondaryAction>
        <FormattedNumber
          classes={{ root: styles.amount }}
          value={amount}
          options={{
            currency: 'RUB',
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }}
          color="textPrimary"
          variant="body1"
          component="span"
        />
      </ListItemSecondaryAction>
    </ListItem>
  );
};

PaymentItem.propTypes = {
  operation: Type.shape({
    id: Type.string.isRequired,
    contractNumber: Type.string.isRequired,
    amount: Type.number.isRequired,
    comment: Type.string,
  }).isRequired,
};

export default PaymentItem;
